import { createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { toRaw } from 'vue';
import Canvas from '@antv/f2-vue';
import { Chart, Interval, Legend } from '@antv/f2';
export default {
  name: 'pie-chart',
  //饼图
  data: function data() {
    return {};
  },
  props: {
    details: {
      type: Object,
      default: function _default() {
        return {
          lowDecibelPercent: 0,
          midDecibelPercent: 0,
          highDecibelPercent: 0,
          lowFrequencyPercent: 0,
          midFrequencyPercent: 0,
          highFrequencyPercent: 0
        };
      }
    },
    type: {
      type: String,
      default: 'ratio'
    }
  },
  computed: {
    chartData: function chartData() {
      return this.formatData(this.details);
    }
  },
  methods: {
    formatData: function formatData(data) {
      if (this.type === 'ratio') {
        if (data.lowDecibelPercent === 0 && data.midDecibelPercent === 0 && data.highDecibelPercent === 0) {
          return [];
        }

        var result = [{
          name: '<50 dB',
          percent: data.lowDecibelPercent || 0,
          a: 'const',
          color: '#FF5B18'
        }, {
          name: '50-70 dB',
          percent: data.midDecibelPercent || 0,
          a: 'const',
          color: '#4B48DC'
        }, {
          name: '>70 dB',
          percent: data.highDecibelPercent || 0,
          a: 'const',
          color: '#3F96F3'
        }];
        return result;
      } else {
        if (data.lowFrequencyPercent === 0 && data.midFrequencyPercent === 0 && data.highFrequencyPercent === 0) {
          return [];
        }

        var _result = [{
          name: this.$t('message.snore.low'),
          subName: this.$t('message.snore.softSnore'),
          percent: data.lowFrequencyPercent || 0,
          a: 'const',
          color: '#FF5B18'
        }, {
          name: this.$t('message.snore.medium'),
          subName: this.$t('message.snore.uvulaSnore'),
          percent: data.midFrequencyPercent || 0,
          a: 'const',
          color: '#4B48DC'
        }, {
          name: this.$t('message.snore.high'),
          subName: this.$t('message.snore.tongueSnore'),
          percent: data.highFrequencyPercent || 0,
          a: 'const',
          color: '#3F96F3'
        }];
        return _result;
      }
    },
    getColor: function getColor() {
      return {
        field: 'name',
        range: ['#FF5B18', '#4B48DC', '#3F96F3'] // 按小、中、大的顺序

      };
    }
  },
  render: function render() {
    var _this = this;

    var chartData = this.chartData;
    var type = this.type;
    if (!chartData.length) return _createVNode("div", {
      "className": "snore-chart-container empty"
    }, null);
    return _createVNode("div", {
      "className": "snore-chart-container"
    }, [_createVNode("div", {
      "className": "chart-container"
    }, [_createVNode(Canvas, {
      "pixelRatio": window.devicePixelRatio
    }, {
      default: function _default() {
        return [_createVNode(Chart, {
          "data": toRaw(chartData),
          "coord": {
            type: 'polar',
            transposed: true
          }
        }, {
          default: function _default() {
            return [_createVNode(Interval, {
              "x": "a",
              "y": "percent",
              "adjust": "stack",
              "color": _this.getColor()
            }, null), type === 'ratio' ? _createVNode(Legend, {
              "position": "right",
              "marker": "square",
              "nameStyle": {
                fontSize: 12,
                fill: 'rgba(0, 0, 0, 0)'
              },
              "valueStyle": {
                fontSize: 12,
                fill: 'rgba(0, 0, 0, 0)'
              },
              "style": {
                backgroundColor: 'rgba(0,0,0,0)',
                right: 0,
                paddingLeft: 40,
                position: 'absolute'
              },
              "itemFormatter": function itemFormatter(value, name) {
                var currentValueItem = _this.chartData.filter(function (item) {
                  return item.name === name;
                });

                if (currentValueItem.length) {
                  value = currentValueItem[0].percent + '%';
                }

                return value;
              }
            }, null) : ''];
          }
        })];
      }
    })]), type === 'ratio' ? _createVNode("div", {
      "className": "legend-container"
    }, [_createVNode("div", {
      "className": "legend-lists"
    }, [_createVNode("div", {
      "className": "legend-item"
    }, [_createVNode("div", {
      "className": "legend"
    }, null), _createVNode("span", {
      "className": "legend-name"
    }, [chartData[0].name]), _createVNode("span", {
      "className": "legend-value"
    }, [chartData[0].percent + '%'])]), _createVNode("div", {
      "className": "legend-item"
    }, [_createVNode("div", {
      "className": "legend"
    }, null), _createVNode("span", {
      "className": "legend-name"
    }, [chartData[1].name]), _createVNode("span", {
      "className": "legend-value"
    }, [chartData[1].percent + '%'])]), _createVNode("div", {
      "className": "legend-item"
    }, [_createVNode("div", {
      "className": "legend"
    }, null), _createVNode("span", {
      "className": "legend-name"
    }, [chartData[2].name]), _createVNode("span", {
      "className": "legend-value"
    }, [chartData[2].percent + '%'])])])]) : '']);
  }
};